import { getSlugForRoute } from '~~/helpers/routes/getPageInformation';
import { ROUTES } from '~~/constants/routes';
import { EXPONDO_BREADCRUMB_NAME } from '~~/constants/breadcrumbs';

export const prepareBreadcrumb = (text: string, link: string, index: number) => {

  return {
    text: index === 0 ? EXPONDO_BREADCRUMB_NAME : text,
    link: index === 0 ? getSlugForRoute(ROUTES.HOME) : `/${link}`,
  };

};
